<template>
  <BaseModal
    :id="'static-new-users'"
    :title="title"
    :size="'lg'"
    :message="message"
  >
    <template v-slot:breadcrumb>
      <Breadcrumb :breadcrumb="breadcrumb_local" />
    </template>
    <template v-slot:content>
      <form class="col-12 p-0" @submit.prevent="sendMassEmail()">
        <div class="row mt-4 ">
          <div class="col-md-12 py-0 mb-1 mb-md-0">
            <div
              class="input-field my-0"
              v-if="users.length && hasPermissions(['Associate Read'])"
            >
              <i class="material-icons prefix iconInput">search</i>
              <input
                id="icon_prefix"
                type="text"
                class="validate inputSearch"
                placeholder="Search"
                v-model="search"
              />
            </div>
          </div>
        </div>
        <div class="row mb-0 no-gutters">
          <div class="col-lg-12">
            <v-card>
              <DinamicTable
                :headers="table_headers"
                :items="users"
                :search="search"
                :checkable="true"
                :updateable="false"
                :selectable_columns="false"
                name="new_users"
                ref="dinamic_table_users"
              />
            </v-card>
          </div>
        </div>
        <CentralLiteButtons
          save_text="Send email <img class='ml-2' width='15px' src='/assets/img/svg/mail-w.svg' alt=''/>"
        />
      </form>
    </template>
  </BaseModal>
</template>

<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import BaseModal from "@/components/BaseModal";
import CentralLiteButtons from "@/components/CentralLiteButtons";
import DinamicTable from "@/components/DinamicTable";
import Resources from "./resources";

export default {
  name: "NewUsersModal",
  props: ["title", "rest_api", "notyf", "breadcrumb"],

  components: {
    Breadcrumb,
    BaseModal,
    CentralLiteButtons,
    DinamicTable,
  },

  data() {
    return {
      message:
        "Selecting new users to send an email to set their first password is an essential part of the application. This allows you to choose which users to send the email to, so they can create their password. The selection process is a vital part of the application, ensuring that the correct users are able to access their accounts.",
      table_headers: Resources.table_new_users_headers,
      users: [],
      search: "",
      breadcrumb_local: JSON.parse(JSON.stringify(this.breadcrumb)),
    };
  },

  methods: {
    async initialSetup() {
      if (this.hasPermissions(["Associate Read"])) {
        const response = await this.get("new_users");

        if (response.status) {
          this.users = response.data.users;
        } else {
          this.error_handling(response);
        }

        this.$refs.dinamic_table_users.select_all = false;
      }
    },

    async sendMassEmail() {
      const users_selected = this.users.filter((item) => item.checked);

      const response = await this.postingByPost(
        "new_users/send_mass_first_password_email",
        {associates: users_selected, new_app: false},
        "static-new-users",
        false
      );

      if (response.status) {
        this.notyf.success("Sending email to users");
      }
    },
  },

  mounted() {
    this.breadcrumb_local[this.breadcrumb.length - 1].arrow =
      "<span class='slash'>/</span>";
    this.breadcrumb_local.push({
      name: "New Users",
      arrow: "",
    });
  },
};
</script>
